import { Box, Image, Text, Flex } from "@chakra-ui/react";
import React from "react";
import { Grid } from "@mantine/core";
import Parse from "parse";

export const ShowEvent = ({
  url,
  imageFile,
  nomEvent,
  secteur,
  typeEvent,
  imageEvent,
  lieu,
  dateDebut,
  duration,
  month,
  prix,
  description,
  dateFin,
  inscrit,
  inscritMax,
}) => {
  const user = Parse.User.current();
  return (
    <Box
      bg={"white"}
      borderRadius="20px"
      borderColor={"red"}
      boxShadow="lg"
      height={["", "", "740px", "740px"]}
      w={["100%", "100%", "calc(100% - 100px)", "calc(100% - 100px)"]}
    >
      <Box
        height={"200px"}
        w="100%"
        borderRadius="20px"
        color={"white"}
        fontSize={"2xl"}
        fontWeight={"bold"}
      >
        {!imageFile ? (
          ""
        ) : (
          <Image
            width="100%"
            height="200px"
            borderTopRadius="20px"
            objectFit="cover"
            src={URL.createObjectURL(imageFile)}
          ></Image>
        )}
        {!url ? (
          ""
        ) : (
          <Image src={url} width="100%" height="150px" objectFit="cover" />
        )}
      </Box>
      <Box h={["100%", "100%", "560px", "560px"]} w="100%">
        <Grid h={["", "", "100%", "100%"]} gutter="xl">
          <Grid.Col
            h={["", "", "100%", "100%"]}
            order={2}
            mt={"10px"}
            key="2"
            xs={8}
          >
            <Box ml={10}>
              <Text
                maxW={"740px"}
                fontSize={"24px"}
                fontWeight={900}
                fontFamily={"Sofia Pro"}
                noOfLines={1}
              >
                {nomEvent}
              </Text>
              <Text
                maxW={"740px"}
                noOfLines={1}
                fontSize={"18px"}
                fontWeight={400}
                fontFamily={"Sofia Pro"}
              >
                {secteur}
              </Text>
              <Text
                maxW={"740px"}
                color={"#F1404B"}
                fontSize={"18px"}
                fontWeight={400}
                noOfLines={1}
                fontFamily={"Sofia Pro"}
              >
                {dateDebut
                  ? `A partir ${
                      ["04", "08", "10"].includes(month) ? "d'" : "de "
                    }`
                  : ""}
                {dateDebut}
              </Text>
              <Text
                maxW={"740px"}
                color={"#F1404B"}
                fontSize={"18px"}
                fontWeight={400}
                noOfLines={1}
                fontFamily={"Sofia Pro"}
              >
                {dateFin ? `jusqu'au ` : ""}
                {dateFin}
              </Text>
              <Text
                maxW={"740px"}
                noOfLines={1}
                fontSize={"18px"}
                fontWeight={400}
                fontFamily={"Sofia Pro"}
              >
                {duration ? "(" + duration + ")" : ""}
              </Text>
              <Text
                maxW={"740px"}
                lineHeight={1.3}
                fontSize={"14px"}
                my={"5px"}
                fontWeight={400}
                fontFamily={"Sofia Pro"}
                noOfLines={6}
              >
                {lieu}
              </Text>
              <Text
                maxW={"740px"}
                fontSize={"14px"}
                fontWeight={400}
                lineHeight={1.3}
                fontFamily={"Sofia Pro"}
                noOfLines={6}
              >
                {typeEvent}
              </Text>
              <Text
                maxW={"740px"}
                fontSize={"14px"}
                lineHeight={1.3}
                fontWeight={400}
                noOfLines={6}
                fontFamily={"Sofia Pro"}
              >
                {description}
              </Text>

              <Text
                mt={"30px"}
                maxW={"740px"}
                fontSize={"18px"}
                lineHeight={1.3}
                fontWeight={900}
                noOfLines={6}
                color={"#F1404B"}
                fontFamily={"Sofia Pro"}
              >
                {inscritMax ? `Places restantes : ${inscritMax - inscrit}` : ""}
              </Text>

              <Text
                maxW={"210px"}
                fontSize={"18px"}
                fontWeight={900}
                fontFamily={"Sofia Pro"}
                noOfLines={1}
                position={["", "", "absolute", "absolute"]}
                bottom={["", "", "110px", "110px"]}
                ml={["", "", "630px", "630px"]}
                color={"#F1404B"}
              >
                Prix de la place : {prix ? `${prix}€ ` : "gratuit"}
              </Text>
            </Box>
          </Grid.Col>
          <Grid.Col
            order={1}
            orderLg={2}
            h={["", "", "100%", "100%"]}
            w={"100%"}
            key="1"
            xs={4}
          >
            <Flex
              h={["", "", "100%", "100%"]}
              w={"100%"}
              alignItems={"center"}
              justifyContent={"center"}
              flexDirection={"column"}
            >
              <Box
                borderWidth="10px"
                boxShadow="lg"
                borderRadius="full"
                borderColor="#AEDFFF"
                width="200px"
                height="200px"
                bg={"white"}
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
              >
                <Image
                  src={user.get("avatar") ? user.get("avatar").url() : ""}
                  borderRadius="full"
                  boxSize="80px"
                  w={"100%"}
                  h={"100%"}
                />
              </Box>
              <Flex
                pt={"20px"}
                alignItems={"center"}
                justifyContent={"center"}
                flexDirection={"column"}
              >
                <Text
                  maxW={"210px"}
                  fontSize={"18px"}
                  fontWeight={400}
                  fontFamily={"Sofia Pro"}
                  noOfLines={1}
                  color={"#CFCFCF"}
                >
                  Organisé par
                </Text>
                <Text
                  maxW={"210px"}
                  fontSize={"18px"}
                  fontWeight={400}
                  fontFamily={"Sofia Pro"}
                  noOfLines={1}
                  color={"#CFCFCF"}
                >
                  {user.get("prenom")}
                </Text>
              </Flex>
            </Flex>
          </Grid.Col>
        </Grid>
      </Box>
    </Box>
  );
};

export default ShowEvent;
